let header = document.querySelector(".header")
let headerBtn = document.querySelector(".header__burger")
let headerLinks = document.querySelectorAll(".header__menuRight ul li a")

headerBtn.addEventListener("click", () => {
    header.classList.toggle("is-on");
    document.body.classList.toggle("header-is-on");
    noscroll(header.classList.contains("is-on"))
})

headerLinks.forEach((a) => {
    a.addEventListener("click", removeHeader)
})

export const breadlinksInit = () => {
    document.querySelectorAll(".Breadcrumb a").forEach((link) => {
        link.addEventListener("click", removeHeader)
    })
}

function removeHeader() {
    let time = 0
    if (innerWidth > 1024) {
        time = 300
    }
    setTimeout(() => {
        header.classList.remove("is-on");
        document.body.classList.remove("header-is-on");
        noscroll(header.classList.contains("is-on"))
    }, time)
}

function noscroll(bool) {
    if (bool) {
        document.addEventListener('touchmove', disableScroll, {
            passive: false
        });
        document.addEventListener('mousewheel', disableScroll, {
            passive: false
        });
    } else {
        document.removeEventListener('touchmove', disableScroll, {
            passive: false
        });
        document.removeEventListener('mousewheel', disableScroll, {
            passive: false
        });
    }
}

function disableScroll(event) {
    event.preventDefault();
}